/**
 * Created by Alex Aguilar on 5/24/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('numberService', numberService);

    function numberService(){
        var service = {
            roundHalfUp: roundHalfUp
        }

        function roundHalfUp(num){
            return Math.round(num);
        }
        return service;
    }
})();
